import React from "react";
import "./NotFound.css";

const NotFound = props => {
    return (
        <div className="container notfound animated rubberBand">
            <p><span>Ups,</span> there is not so much going on in here. Go back to Home.</p>
        </div>
    );
};



export default NotFound;
